import { gql } from "@apollo/client";

// ESGT Queries
export const FETCH_ESGT_FOLDERS = gql`
  query GetESGTFolders(
    $where: ESGTFolderWhereInput!
    $orderBy: ESGTOrderByInput!
  ) {
    getESGTFolders(where: $where, orderBy: $orderBy) {
      id
      name
      parentId
      folders {
        id
        name
        createDate
        parentId
        createDate
        createdBy {
          name
        }
      }
      files {
        id
        name
        link
        parentId
        createDate
        createdBy {
          name
        }
      }
      createDate
      deleted
    }
  }
`;

export const FETCH_ESGT_FILES = gql`
  query GetESGTFiles(
    $name: String!
    $organizationId: ID!
    $projectId: Int!
    $orderBy: ESGTOrderByInput
  ) {
    getESGTFiles(
      name: $name
      organizationId: $organizationId
      projectId: $projectId
      orderBy: $orderBy
    ) {
      id
      name
      link
      parentId
      createdBy {
        name
      }
      createDate
    }
  }
`;

export const CREATE_ESGT_FOLDER = gql`
  mutation CreateESGTFolder(
    $name: String!
    $parentId: ID
    $organizationId: ID!
    $projectId: Int!
  ) {
    createESGTFolder(
      data: {
        name: $name
        parentId: $parentId
        organizationId: $organizationId
        projectId: $projectId
      }
    ) {
      id
      message
      parentId
      parentName
    }
  }
`;

export const CREATE_ESGT_FILE = gql`
  mutation CreateESGTFile(
    $link: String!
    $name: String!
    $organizationId: ID!
    $parentId: ID
    $projectId: Int!
  ) {
    createESGTFile(
      data: {
        link: $link
        name: $name
        parentId: $parentId
        organizationId: $organizationId
        projectId: $projectId
      }
    ) {
      id
      message
      parentId
      parentName
    }
  }
`;

export const RENAME_ESGT_FOLDER = gql`
  mutation RenameESGTFolder($data: UpdateFolderOrFileInput!) {
    updateESGTFolder(data: $data) {
      id
      name
      parentId
      folders {
        id
        name
        createDate
        parentId
        createDate
        createdBy {
          name
        }
      }
      files {
        id
        name
        link
        parentId
        createDate
        createdBy {
          name
        }
      }
      createDate
      deleted
    }
  }
`;

export const RENAME_ESGT_FILE = gql`
  mutation RenameESGTFile($data: UpdateFolderOrFileInput!) {
    updateESGTFile(data: $data) {
      id
      name
      link
      parentId
      createDate
      createdBy {
        name
      }
    }
  }
`;

export const DELETE_ESGT_FOLDER = gql`
  mutation DeleteESGTFolder($id: ID!) {
    deleteESGTFolder(id: $id) {
      message
      id
    }
  }
`;

export const DELETE_ESGT_FILE = gql`
  mutation DeleteESGTFile($id: ID!) {
    deleteESGTFile(id: $id) {
      message
      id
    }
  }
`;
